<template>
    <div class="tile-content tile-content-secondary">
        <div class="grid-content">
            <div class="grid-item grid-item-full">
                <p class="stack-m">Add or remove tags for the related customer.</p>
            </div>
            <div class="grid-item grid-item-full">
                <select-tags
                    label="Add Tags"
                    :do-search="doSearchFor(names.add)"
                    :get-init-values="getInitValues"
                    :selected-tags="toAdd"
                    :vselect-id="names.add"
                    :loading="isLoading[names.add]"
                    @option-removed="onOperation(names.remove, $event)"
                    @option-selected="onOperation(names.add, $event)"
                />
            </div>
            <div class="grid-item grid-item-full">
                <select-tags
                    label="Remove Tags"
                    :do-search="doSearchFor(names.remove)"
                    :get-init-values="getInitValues"
                    :selected-tags="toRemove"
                    :vselect-id="names.remove"
                    :loading="isLoading[names.remove]"
                    @option-removed="onOperation(names.remove, $event)"
                    @option-selected="onOperation(names.add, $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import BaseAction from '../base-action';
    import SelectTags from './components/select-tags';
    import TagModel from '@/common/models/tag-model';

    const getName = tagObj => tagObj.getName();

    export default {
        name: 'tag-or-untag-customer',
        extends: BaseAction,
        components: {SelectTags},

        data() {
            return {
                actionClone: {},
                names: {
                    add: 'add',
                    remove: 'remove',
                },
                toAdd: [],
                toRemove: [],
                isLoading: {
                    add: true,
                    remove: true,
                },
            };
        },

        watch: {
            action: {
                handler(value) {
                    const newTagModel = name => new TagModel({name});
                    this.actionClone = value.cloneSelf();
                    this.toAdd = [...this.actionClone.addingTags.map(newTagModel)];
                    this.toRemove = [...this.actionClone.removingTags.map(newTagModel)];
                },
                immediate: true,
            },
        },

        methods: {
            updateAction() {
                this.actionClone.addingTags = [...this.toAdd.map(getName)];
                this.actionClone.removingTags = [...this.toRemove.map(getName)];
                this.$emit('input', this.actionClone);
            },

            onOperation(operation, {tag, instanceId}) {
                const instanceToTagsMap = {
                    [this.names.add]: 'toAdd',
                    [this.names.remove]: 'toRemove',
                };
                const operationToCallbackMap = {
                    [this.names.add]: arr => [...arr, tag],
                    [this.names.remove]: arr => arr.filter(el => el.name !== tag.name),
                };
                const desiredArray = instanceToTagsMap[instanceId];
                this[desiredArray] = operationToCallbackMap[operation](this[desiredArray]);

                this.updateAction();
            },

            doSearchFor(target) {
                return (...args) => this.doSearch(...args, target);
            },

            async doSearch($event, query = {}, target) {
                const apiBaseParams = {
                    limit: 1000,
                    sort: '-createdTime',
                };
                let tagOptions = [];
                try {
                    this.isLoading[target] = true;
                    const params = {...apiBaseParams, ...query, q: $event};
                    const {items: tagItems} = await this.$api(({tags}) => tags.getAll(params));
                    tagOptions = tagItems.map(item => new TagModel(item.fields));
                    return tagOptions;
                } catch (error) {
                    this.$toast.fromError(error, 'Something went wrong, please try again or contact support.');
                    return tagOptions;
                } finally {
                    this.isLoading[target] = false;
                }
            },

            async getInitValues($event) {
                let tagOptions = [];
                try {
                    this.toggleAllLoadState(true);
                    const tagsData = await this.$api(({tags}) => Promise.all($event
                        .map(getName)
                        .map(name => tags.get({tag: name}))));
                    tagOptions = tagsData.map(item => new TagModel(item.fields));
                    return tagOptions;
                } catch (error) {
                    this.$toast.fromError(error, 'Something went wrong, please try again or contact support.');
                    return tagOptions;
                } finally {
                    this.toggleAllLoadState(false);
                }
            },

            toggleAllLoadState(state) {
                this.isLoading.add = state;
                this.isLoading.remove = state;
            },
        },
    };
</script>
